
// custom js  graf lantz 2022



// WINDOW SCROLLED
$(window).scroll(function() {  
  
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 500) {
      $("body").addClass("scrolled2");
  } else {
      $("body").removeClass("scrolled2");
  }
  if (scroll >= 60) {
      $("body").addClass("first-scrolled2");
  } else {
      $("body").removeClass("first-scrolled2");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  
});




$(document).ready(function() {



	$('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');
  }, 3000);






  $('.mcs-nav-shop').hover(function() {
    $('.mcs-dropdown.shop-dropdown').addClass('active');
  }, function() {
    $('.mcs-dropdown.shop-dropdown').removeClass('active');
  });
  $(".mcs-nav-shop-by-color").hover(
    function () {
      $(".mcs-dropdown.color-dropdown").addClass("active");
    },
    function () {
      $(".mcs-dropdown.color-dropdown").removeClass("active");
    }
  );

  $('.mcs-nav-materials-story').hover(function() {
    $('.mcs-dropdown.wool-dropdown').addClass('active');
  }, function() {
    $('.mcs-dropdown.wool-dropdown').removeClass('active');
  });

  $('.mcs-nav-about-us').hover(function() {
    $('.mcs-dropdown.about-dropdown').addClass('active');
  }, function() {
    $('.mcs-dropdown.about-dropdown').removeClass('active');
  });
  // main drop
  $('.mcs-dropdown').hover(function() {
    $(this).addClass('active');
  }, function() {
    $(this).removeClass('active');
  });






  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();

  $('.mcs-simple-slider').flickity({
    autoPlay: 4000,
    pauseAutoPlayOnHover: true,
    wrapAround: true,
    pageDots: false,
    cellAlign: 'left'
  });

  $('.mcs-simple-slider').each(function() {
  if ($(this).find('div.carousel-cell').length === 1) {
    $(this).find('button.flickity-prev-next-button.previous, button.flickity-prev-next-button.next, ol.flickity-page-dots').hide();
  }
});



});






$(window).on('load', function() {


  //$('.site-overlay').addClass('loaded');

  



});


